// extracted by css-extract-rspack-plugin
export default {"card":"card-dqsSk3"};